import {
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { Field, FieldGroup } from "@/components/ui/field"
import { ConnectSubjectDialog } from "@/components/kep/ConnectSubjectDialog"
import { LoginFrame } from "@/components/login/LoginFrame"
import {authClient} from "@/lib/api/auth.ts";

// L4 in login.md — the one page shell shared by all of CD1's outcomes.
export function ConnectSubjectStep() {
  const { data } = authClient.useSession()
  return (
    <LoginFrame>
      <CardHeader>
        <CardTitle className="text-center">Логін Успішний</CardTitle>
        <CardDescription>
          <p>
            До Вашого облікового запису ще не прив'язано жодного суб'єкта ОТК.
            Це можна зробити за допомогою КЕП (електронного підпису)
            відповідальної особи, керівника або заступника керівника. Якщо у
            вас є такий КЕП, ви можете продовжити, натиснувши кнопку нижче.
          </p>
          <p>
            В іншому випадку, зверніться до відповідальної особи вашого
            суб'єкта ОТК.
          </p>
        </CardDescription>
      </CardHeader>
      <CardContent>
        <FieldGroup>
          <Field>
            <ConnectSubjectDialog email={data?.user.email ?? ""} />
          </Field>
        </FieldGroup>
      </CardContent>
    </LoginFrame>
  )
}
